export enum FcmPushChannel {
  RESERVATION = 'RESERVATION',
  ORDER = 'ORDER',
  PAYMENT = 'PAYMENT',
  DEFAULT = 'DEFAULT',
  MARKETING = 'MARKETING',
}
